app.controller('BrowseEditSolutionContextController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.is_edit_mode = true;

    $scope.doShowTemplate = function () {
        return true;
    }
    $scope.fullOnWhite = function () {
        return true;
    }

    function getPropertyModel() {
        const editingModelID = $scope.editing_model_id ? $scope.editing_model_id : "";
        const cartModel = $scope.currentCartModel ? $scope.currentCartModel() : null;
        const propertyModels = cartModel && cartModel.property_models ? cartModel.property_models : {};
        return editingModelID ? propertyModels[editingModelID] : null;
    }

    $scope.getEditNavigationIDs = function () {
        const propertyModel = getPropertyModel();
        return propertyModel ? propertyModel.edit_navigation_ids : {};
    }

    $scope.getEditNavigationValues = function () {
        const propertyModel = getPropertyModel();
        return propertyModel ? propertyModel.edit_navigation_values : {};
    }

    $scope.getEditChoiceIDs = function () {
        const propertyModel = getPropertyModel();
        return propertyModel ? propertyModel.edit_choice_ids : {};
    }

    $scope.onChoiceSelected = function (event, choiceID) {
        event.preventDefault();
        if ($scope.onPropertySelected) {
            $scope.onPropertySelected(choiceID)
        }
        return false;
    }

    $scope.isChoiceSelected = function (choiceID) {
        const propertyModel = getPropertyModel();
        return propertyModel && (propertyModel.current_choice_id === choiceID);
    }

}]);